export function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

export function changesDetail(data) {
  switch (data.name) {
    case "MATTER":
      if (data.action === "CREATE") {
        return "کاری دروست کرد.";
      }
      if (data.action === "UPDATE") {
        return "نوێکردنەوەی کار.";
      }
      break;
    case "ACTIVITY":
      if (data.action === "CREATE") {
        return "چالاکی دروست کرد.";
      }
      if (data.action === "UPDATE") {
        return "نوێکردنەوەی چالاکی.";
      }
      if (data.action === "DELETE") {
        return "سڕینەوەی چالاکی.";
      }
      break;
    case "EXPENSE":
      if (data.action === "CREATE") {
        return "خەرجی دروست کرد.";
      }
      if (data.action === "UPDATE") {
        return "نوێکردنەوەی خەرجی.";
      }
      if (data.action === "DELETE") {
        return "سڕینەوەی خەرجی.";
      }
      break;
    case "INVOICE":
      if (data.action === "CREATE") {
        return "پسوڵەی دروست کرد.";
      }
      if (data.action === "UPDATE") {
        return "نوێکردنەوەی پسوڵە.";
      }
      if (data.action === "DELETE") {
        return "سڕینەوەی پسوڵە.";
      }
      break;
    case "PAYMENT INVOICE":
      if (data.action === "CREATE") {
        return "پارەدانی پسوڵەی دروست کرد.";
      }
      if (data.action === "UPDATE") {
        return "نوێکردنەوەی پارەدانی پسوڵە.";
      }
      if (data.action === "DELETE") {
        return "سڕینەوەی پارەدانی پسوڵە.";
      }
      break;
    case "REFUND":
      if (data.action === "CREATE") {
        return "پارەدانی پێشەکی دروست کرد.";
      }
      if (data.action === "UPDATE") {
        return "نوێکردنەوەی پارەدانی پێشەکی.";
      }
      if (data.action === "DELETE") {
        return "سڕینەوەی پارەدانی پێشەکی.";
      }
      break;
    case "MONEY OUT":
      if (data.action === "CREATE") {
        return "دەرکردنی پارەی ئەنجامدا";
      }
      if (data.action === "UPDATE") {
        return "دەرکردنی پارەی نوێکردەوە.";
      }
      if (data.action === "DELETE") {
        return "دەرکردنی پارەی سڕیەوە.";
      }
      break;
    case "SHEWA":
      if (data.action === "CREATE") {
        return "شێوەی دروست کرد.";
      }
      if (data.action === "UPDATE") {
        return "نوێکردنەوەی شێوە.";
      }
      if (data.action === "DELETE") {
        return "سڕینەوەی شێوە.";
      }
      break;
    default:
      return "";
  }
}


export function kurdishInteger(data) {
  // for(let i = 0;i<data.length;i++){
    
  // }
  // switch (data.name) {
    




  // }

}

export const paginationTable = (option, sorter) => {
  let query = "";

  if (option !== {}) {
    let page = option.current ? "page=" + option.current : "";
    let items = option.pageSize ? "&items=" + option.pageSize : "";
    let sort = sorter ? "&sort=" + sorter.order : "";
    query = `?${page}${items}${sort}`;
  }

  return query;
};
